import { Label } from "reactstrap";
import React, { useEffect } from "react";
import axios from "axios";
import { routes } from "./General";
import moment from "moment";
import { useParams } from "react-router-dom";
import { useUser } from "../custom-hooks/useUser";

export const DatosContratante = ({ setCliente, item }) => {
    const user = useUser();
    let { id } = useParams();

    useEffect(() => {
        fetchData();
    }, [user.cdCliente, id]);

    const fetchData = () => {
        axios
            .get(routes.api + "/usuario", {
                params: {
                    cdCliente: id || user.cdCliente,
                },
            })
            .then(resp => {
                let cliente = resp.data;
                cliente.fC = cliente.fC ? new Date(cliente.fC) : null;
                setCliente(cliente);
            })
            .catch(console.log);
    };
    const genero = gen => {
        let ret;
        switch (gen) {
            case "M":
                ret = "MASCULINO";
                break;
            case "F":
                ret = "FEMENINO";
                break;
            case "S":
                ret = "SIN DEFINIR";
                break;
            default:
                ret = " ";
                break;
        }
        return ret;
    };

    return (
        <>
            <div className={"col-md-8 my-4"}>
                <div className="row">
                    <div className="col-12 col-md-6">
                        <div className="row">
                            <div className="col-6 text-right">
                                <Label className="font-weight-bold ">Cédula/RUC:&nbsp;</Label>
                            </div>
                            <div className="col-6 ">
                                <span>{item.rucCed}</span>
                            </div>
                            <div className="col-6 text-right">
                                <Label className="font-weight-bold text-right">Nombres:&nbsp;</Label>
                            </div>
                            <div className="col-6 ">
                                <span>{item.nmCliente}</span>
                            </div>
                            <div className="col-6 text-right">
                                <Label className="font-weight-bold text-right">Apellido:&nbsp;</Label>
                            </div>
                            <div className="col-6 ">
                                <span>{item.apCliente}</span>
                            </div>
                            <div className="col-6 text-right">
                                <Label className="font-weight-bold text-right">Género:&nbsp;</Label>
                            </div>
                            <div className="col-6 ">
                                <span>{genero(item.genero)}</span>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-6">
                        <div className="row">
                            <div className="col-6 text-right">
                                <Label className="font-weight-bold text-left">Estado Civil:&nbsp;</Label>
                            </div>
                            <div className="col-6">
                                <span>{item.estadoCivil}</span>
                            </div>
                            {("CASADO" === item.estadoCivil || "CASADO/A" === item.estadoCivil) && (
                                <>
                                    <div className="col-6 text-right">
                                        <Label className="font-weight-bold">Nombre Cónyuge:&nbsp;</Label>
                                    </div>
                                    <div className="col-6">
                                        <span>
                                            {item.nmConyuge} {item.apConyuge}
                                        </span>
                                    </div>
                                    <div className="col-6 text-right">
                                        <Label className="font-weight-bold">Fc. Nacimiento:&nbsp;</Label>
                                    </div>
                                    <div className="col-6">
                                        <span>
                                            {item.fcNacimiento
                                                ? moment(item.fcNacimiento)
                                                      .locale("moment/locale/es")
                                                      .format("DD/MM/YYYY")
                                                : "-"}
                                        </span>
                                    </div>
                                </>
                            )}
                            <div className="col-6 text-right">
                                <Label className="font-weight-bold">Título:&nbsp; </Label>
                            </div>
                            <div className="col-6">
                                <span>{item.titulo}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};
